module.exports = __webpack_public_path__ + "img/au04.e5067099.jpg";